/* eslint-disable react/jsx-pascal-case */
import {
    Row,
    Col,
    Modal,
    Button,
    Form,
} from "../../ui/ot";

import React, {
    useContext,
    useEffect,
    useRef,
    lazy,
    Suspense,
    useState,
} from "react";
import PageManagementForm from "./page_management_form";

const PageManagementModal = ({
    axiosMode = "post",
    propsForm,
    propsOpen = null,
    propsLoading = null,
    propsSetOpen = () => {},
    onFinish = () => {},
    editcard,
}) => {
    const axiosModelanguage = {
        post: "新增",
        patch: "修改",
    };
    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formReloadCount, setFormReloadCount] = useState(0);
    const showModal = () => {
        // setFormReloadCount((pre) => pre + 1);
        if (propsOpen === null) {
            setIsModalOpen(true);
        } else {
            propsSetOpen(true);
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        } else {
            propsSetOpen(false);
        }
    };

    const handleOk = () => {
        setLoading(true);
        if (propsForm) {
            propsForm.submit();
        } else {
            // form.submit();
        }
    };

    const handleCancel = () => {
        closeModal();
    };
    const onFormFinish = (values) => {
        onFinish(values);
    };
    useEffect(() => {
        // setFormReloadCount((pre) => pre + 1);
    }, [propsOpen]);

    return (
        <>
            {propsOpen === null && (
                <Button type="primary" onClick={showModal}>
                    {`${axiosModelanguage[axiosMode]}頁面`}
                </Button>
            )}

            <Modal
                style={{ top: 10 }}
                title={`${axiosModelanguage[axiosMode]}頁面`}
                open={propsOpen === null ? isModalOpen : propsOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                confirmLoading={propsLoading === null ? loading : propsLoading}
                maskClosable={false}
                contentStyle={{
                    padding: 16,
                }}
                width={700}
                okText={"送出"}
                cancelText={"取消"}
            >
                <Row
                    style={{
                        // maxHeight: "80vh",
                        // overflowX: "scroll",
                        // overflowY: "scroll",
                    }}
                >
                    <Col span={24}>
                        <PageManagementForm
                            formReloadCount={formReloadCount}
                            open={propsOpen === null ? isModalOpen : propsOpen}
                            axiosMode={axiosMode}
                            propsForm={propsForm ? propsForm : form}
                            onFormFinish={onFormFinish}
                            editcard={editcard}
                        />
                    </Col>
                </Row>
            </Modal>
        </>
    );
};

export default PageManagementModal;
